import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ClanShortInfo} from "@/store/clan/types";
import {ListService} from "@/services/list-service";
import {ClanBonusPanel} from "@/scenes.ui.clan/clan-bonus-panel";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import SecurityStore from "@/store/security";
import PlayerStore from "@/store/player";
import OnceCaller from "@/utils/once-caller";
import SoundUtils from "@/utils/sound-utils";
import {InputTextPanel} from "@/scenes.ui/input-text-panel";
import ClanStore from "@/store/clan";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";

export class ClanDetailsPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, c: ClanShortInfo, participantsCallback: () => unknown,
                applyCallback: (() => unknown) | undefined, forumCallback: (() => unknown) | undefined, changeClanNameCallback: (() => unknown) | undefined) {
        super(scene, canvas, ' ' + Tr('klan'));
        this.setDepth(ListService.DEPTH + 1);

        let blockFirst = TextUtils.addTextAdvanced(scene, c.name + Tr('level.braket') + c.level + ')', 0, -185,
            '#f3f3f3', 22, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let clanBonusPanel = new ClanBonusPanel(scene, 0, blockFirst.y / CU.S + 40, c.clanExpRatio, c.clanDefenceChance, c.raidDistance, c.gears, false);

        let blockSecond = TextUtils.addTextAdvanced(scene, Tr('uchastnikov') + c.membersCurr + '/' + c.membersMax, 0, clanBonusPanel.y / CU.S + 40,
            '#bdbdbd', 16, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let pickActionText = TextUtils.addTextByFamily(scene, Tr('viberite.deystvie'), 0, -10,
            '#ffd465', 18, 'bold', 300, Fonts.MYRIADPRO_REGULAR);
        this.add([blockFirst, clanBonusPanel, blockSecond, pickActionText]);

        let xx = 120;
        let yy = 150;
        if (applyCallback && c.hasGuestForum) {
            SpriteUtils.scale(this.addCustomButton(-xx, yy, Tr('uchastniki'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, participantsCallback), 0.85);
            SpriteUtils.scale(this.addCustomButton(0, yy, Tr('frm'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, forumCallback), 0.85);
            SpriteUtils.scale(this.addCustomButton(xx, yy, Tr('podat.zajavku'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_MAIL, applyCallback), 0.85);
        } else if (!applyCallback && c.hasGuestForum) {
            this.addCustomButton(-xx, yy, Tr('uchastniki'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, participantsCallback);
            this.addCustomButton(xx, yy, Tr('frm'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, forumCallback);
        } else if (applyCallback && !c.hasGuestForum) {
            this.addCustomButton(-xx, yy, Tr('uchastniki'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, participantsCallback);
            this.addCustomButton(xx, yy, Tr('podat.zajavku'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_MAIL, applyCallback);
        } else {
            this.addCustomButton(0, yy, Tr('uchastniki'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, participantsCallback);
        }
        if(PlayerStore.hasAdminAccess()) {
            SpriteUtils.scale(this.addCustomButton(150, -15, "", Keys.CL_RECRUITING, undefined, undefined, changeClanNameCallback), 0.7);
        }
    }

}
